<form (ngSubmit)="onSubmit()">
  <header class="dialog-header">
    <h2 id="dialogo-renomear-aba-titulo">Renomear aba</h2>
    <button type="button" class="icon-btn" aria-label="Fechar" appTooltip="Fechar" (click)="dialogRef.close()">
      <svg-icon src="assets/mdi/close.svg" aria-hidden="true" />
    </button>
  </header>

  <div class="dialog-body">
    <label class="field">
      <span class="field-label">Nome da aba</span>
      <input
        #input
        class="input"
        name="title"
        placeholder="Olá Mundo"
        required
        autocomplete="off"
        [(ngModel)]="title"
      />
    </label>
  </div>

  <footer class="dialog-footer">
    <button type="button" class="btn" (click)="dialogRef.close()">Cancelar</button>
    <button type="submit" class="btn btn-primary" [attr.aria-disabled]="!title().trim() || null">Renomear</button>
  </footer>
</form>
